// extracted by mini-css-extract-plugin
export default {"TypesCell__text":"TypesCell_TypesCell__text__EM1IV"};